import { ReactNode } from "react";
import styles from './PrizeInputSection.module.css';

interface IPrizeInputSection {
  children: ReactNode;
  header: string;
  subText: string;
}  

const PrizeInputSection = ({ children, header, subText }: IPrizeInputSection) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <p className={styles.header}>{header}</p>
      <p className={styles.subheading}>{subText}</p>
      {children}
    </div>
  );
};

export default PrizeInputSection;